'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);


var _components = require('../../components');





var _EditOwnerRealtor = require('../EditOwnerRealtor/EditOwnerRealtor');var _EditOwnerRealtor2 = _interopRequireDefault(_EditOwnerRealtor);

var _constants = require('../../constants');




var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _formatAddress = require('../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);
var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _helpers = require('../../containers/EditCompanyByOwner/helpers');


var _EditCompanyByOwnerForm = require('./EditCompanyByOwnerForm.scss');var styles = _interopRequireWildcard(_EditCompanyByOwnerForm);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helper
// Styles
var
EditCompanyByOwnerForm = function (_Component) {_inherits(EditCompanyByOwnerForm, _Component);function EditCompanyByOwnerForm() {var _temp, _this, _ret;_classCallCheck(this, EditCompanyByOwnerForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    getPublicId = function (image) {return image.public_id ? image.public_id : image.full && image.full.split('/').pop();}, _this.

    addImagesToUnsuspend = function (values) {var _values$image =
      values.image,image = _values$image === undefined ? {} : _values$image,_values$images = values.images,images = _values$images === undefined ? [] : _values$images,_values$realtors = values.realtors,realtors = _values$realtors === undefined ? [] : _values$realtors;
      var ids = [];

      image && image.link && ids.push(image.link);
      images.forEach(function (_ref) {var link = _ref.link;return link && ids.push(link);});
      realtors.forEach(function (item) {
        var link = (0, _get2.default)(item, 'image.link');
        !!link && ids.push(link);
      });

      ids.forEach(function (id) {return _this.props.addAssetToUnsuspend({ type: 'image', id: id });});
    }, _this.

    companyEdit = function (formValues) {
      var agency_id = (0, _get2.default)(_this.props, 'userData.data.agent_data.agency_id');
      var access_token = (0, _get2.default)(_this.props, 'userData.data.access_token');
      var data = (0, _helpers.formatCompanyDataForEditRequest)(formValues, _this.props.initialValues);

      _this.addImagesToUnsuspend(data);
      _this.props.sendEditCompanyByOwnerForm({
        id: agency_id,
        data: (0, _omit2.default)(data, ['title', 'email']),
        access_token: access_token });

    }, _this.

    companyCreate = function (formValues) {
      var data = (0, _helpers.formatCompanyDataForEditRequest)(formValues, {});
      var access_token = (0, _get2.default)(_this.props, 'userData.data.access_token');
      var email = (0, _get2.default)(_this.props, 'userData.data.email');
      data.owner_id = (0, _get2.default)(_this.props, 'userData.data.id');
      data.title = data.name;
      data.email = email;

      _this.addImagesToUnsuspend(data);
      _this.props.createCompanyByOwner({ data: data, access_token: access_token });
    }, _this.

    formSubmitHandler = function (formValues) {var _this$props =
      _this.props,locale = _this$props.locale,fields = _this$props.fields,countryCode = _this$props.countryCode,phoneNumber = _this$props.phoneNumber;
      var userHasCompany = (0, _get2.default)(_this.props, 'userData.data.agent_data.agency_id');

      var formattedPhone = (0, _formatPhoneNumber.normalizePhoneAndCountryCode)(phoneNumber, countryCode);

      var companyBranches = formValues.branches.map(function (item, index) {
        var address = fields.branches[index].address;

        return Object.assign({},
        item, {
          address: (0, _formatAddress2.default)(address[locale] || address.en),
          place_id: address.place_id });

      });

      var company = Object.assign({}, formValues, { branches: companyBranches, phone_number: formattedPhone });

      if (userHasCompany) {
        _this.companyEdit(company);
      } else {
        _this.companyCreate(company);
      }
    }, _this.

    formatImageForServer = function (image) {return {
        _id: image._id,
        link: _this.getPublicId(image),
        description: image.description,
        angle: image.angle || 0 };}, _this.


    handleClick = function (evt) {
      _this.props.handleSubmit(_this.formSubmitHandler)(evt);
    }, _this.

    fetchReCaptchaToken = function (evt) {
      _this.props.fetchReCaptchaToken(evt);
      _this.props.handleSubmit(_this.formSubmitHandler)(evt);
    }, _this.

    changeImages = function (data, name, multiple) {
      var image = data.length ? data[0] : {};
      var formData = null;

      if (data.length) {
        formData = multiple ? data.map(_this.formatImageForServer) : _this.formatImageForServer(image);
      }

      _this.updateContent(formData, name);
    }, _this.

    fetchInitialImageValue = function (name) {
      var data = (0, _get2.default)(_this.props, 'initialValues.' + name, null);
      if (!data) {return null;}

      var formatted = [];

      if (data instanceof Array) {
        formatted = _components.UploadAssetWidget.formatInitialImages(data);
        return formatted;
      }if (data instanceof Object) {
        return [data];
      }

      var logoObject = _components.UploadAssetWidget.convertLinkToImageObject(data);
      formatted = _components.UploadAssetWidget.formatInitialImages([logoObject]);

      return formatted;
    }, _this.

    deleteImages = function (id, name) {
      var images = (0, _get2.default)(_this.props, 'fields.images', []);
      var formData = images.filter(function (item) {return item._id !== id;});
      _this.updateContent(formData, name);
    }, _this.

    addDescription = function (id, newDescription) {
      var images = (0, _get2.default)(_this.props, 'fields.images', []);
      var formData = images.map(function (item) {
        var description = item.description;

        if (id === item._id) {
          description = newDescription;
        }

        return Object.assign({}, item, { description: description });
      });

      _this.updateContent(formData, 'images');
    }, _this.

    rotateImage = function (id, newAngle, name) {
      var images = (0, _get2.default)(_this.props, 'fields.' + name, []);
      var formData = images.map(function (item) {
        var angle = item.angle;

        if (id === item._id) {
          angle = newAngle;
        }

        return Object.assign({}, item, { angle: angle });
      });

      _this.updateContent(formData, name);
    }, _this.

    updateContent = function (data, key) {return _this.props.change(key, data);}, _this.

    formatTypeOptions = function () {return (0, _constants.getProfessionalsTypes)(_this.props.translate).
      filter(function (_ref2) {var type = _ref2.type;return !(0, _get2.default)(_this.props, 'initialValues.verified') || type === (0, _get2.default)(_this.props, 'initialValues.type');}).
      map(function (_ref3) {var type = _ref3.type,title = _ref3.title;return {
          label: _react2.default.createElement('span', null, title),
          value: type };});}, _this.


    handleSelectFlag = function (value, flag) {return (
        _this.props.onPhoneChange(null, value || _this.props.phoneNumber, flag));}, _this.

    renderInput = function (data) {var
      input = data.input,label = data.label,placeholder = data.placeholder,type = data.type,_data$meta = data.meta,touched = _data$meta.touched,error = _data$meta.error,active = _data$meta.active;
      return (
        _react2.default.createElement('span', null,
          _react2.default.createElement('input', _extends({
            className: (0, _classnames2.default)({ 'has-error': error && !active && touched, touched: touched }, 'form-control') },
          input, {
            placeholder: placeholder || label,
            type: type })),

          touched &&
          error && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', 'required'))));


    }, _this.

    renderField = function (name, normalizer, placeholder) {return (
        _react2.default.createElement(_reduxForm.Field, _extends({
          name: name,
          type: 'text',
          component: _this.renderInput,
          label: _this.props.translate('editOwner', name),
          placeholder: placeholder },
        !!normalizer ? { normalize: normalizer } : {})));}, _this.



    renderPhoneNumber = function (_ref4) {var input = _ref4.input,phoneNumber = _ref4.phoneNumber,_ref4$meta = _ref4.meta,error = _ref4$meta.error,touched = _ref4$meta.touched;return (
        _react2.default.createElement('div', { className: styles.phoneNumber },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            autoPlaceholder: false,
            containerClassName: 'intl-tel-input',
            fieldName: input.name,
            placeholder: _this.props.translate('editOwner', 'phone_number'),
            value: phoneNumber,
            inputClassName: 'form-control phone-input',
            preferredCountries: _constants.PREFERRED_COUNTRIES,
            onPhoneNumberChange: _this.props.onPhoneChange,
            onSelectFlag: _this.handleSelectFlag,
            useMobileFullscreenDropdown: false,
            separateDialCode: true,
            nationalMode: false }),

          !!error && touched &&
          _react2.default.createElement('span', { className: styles.required },
            _this.props.translate('errorFieldMessages', 'phone-number'))));}, _this.





    renderUploadAssetWidget = function (_ref5) {var _ref5$meta = _ref5.meta,meta = _ref5$meta === undefined ? {} : _ref5$meta,classNames = _ref5.classNames,_ref5$input = _ref5.input;_ref5$input = _ref5$input === undefined ? {} : _ref5$input;var name = _ref5$input.name,multiple = _ref5.multiple,withCropper = _ref5.withCropper;var
      touched = meta.touched,error = meta.error;
      var changeImages = function changeImages(images) {return _this.changeImages(images, name, multiple);};
      var deleteImages = function deleteImages(id) {return _this.deleteImages(id, name);};
      var rotateImage = function rotateImage(id, newAngle) {return _this.rotateImage(id, newAngle, name);};

      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_components.UploadAssetWidget, {
            multiple: multiple,
            withOutVideo: true,
            openMessageModal: _this.props.openMessageModal,
            images: _this.props.fields[name] || [],
            translate: _this.props.translate('uploadWidget'),
            rootTranslate: _this.props.translate,
            isMobile: _this.props.isMobile,
            initialImages: _this.fetchInitialImageValue(name),
            uploadInProgress: function uploadInProgress(status) {return _this.setState({ uploadPhotoInProgress: status });},
            updateContent: changeImages,
            contentUploaded: changeImages,
            markAssetToDelete: _this.props.addAssetToDelete,
            suspendedUpload: true,
            className: (0, _classnames2.default)(classNames, { 'has-error': !!error && touched, touched: touched }),
            deleteContentItem: deleteImages,
            addDescription: _this.addDescription,
            rotateImage: rotateImage,
            userToken: (0, _get2.default)(_this.props, 'userData.data.access_token'),
            withCropper: withCropper }),

          !!error && touched && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', 'required'))));


    }, _this.

    renderRealtorImageComponent = function (name) {return _this.renderUploadAssetWidget({ className: 'realtorImage', input: { name: name }, withCropper: true });}, _this.
    renderLogoUploadAssetWidget = function (event) {return _this.renderUploadAssetWidget(Object.assign({}, event, { withCropper: true }));}, _this.

    renderCheckbox = function (_ref6) {var input = _ref6.input,label = _ref6.label;return (
        _react2.default.createElement(_components.OMCheckbox, {
          id: input.name,
          label: label,
          field: Object.assign({}, input, { checked: input.value }) }));}, _this.



    renderIsCommunityMember = function () {return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'is_community_member',
          label: '' + _this.props.translate('editOwner', 'isCommunityMember'),
          component: _this.renderCheckbox }));}, _this.



    renderSelectField = function (_ref7) {var input = _ref7.input,meta = _ref7.meta;
      var options = _this.formatTypeOptions();
      var shouldShowError = !!(meta.touched && meta.error && !meta.active);

      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_reactSelect2.default, _extends({},
          input, {
            onChange: function onChange(option) {return input.onChange(option.value);},
            options: options,
            searchable: false,
            clearable: false,
            instanceId: 'professional_type',
            rtl: _this.props.isRtl,
            placeholder: '' + _this.props.translate('editOwner', 'type'),
            className: (0, _classnames2.default)({ 'has-error': shouldShowError }) })),

          shouldShowError && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', 'required'))));


    }, _this.

    renderSelect = function () {return _react2.default.createElement(_reduxForm.Field, { name: 'type', locale: _this.props.locale, component: _this.renderSelectField });}, _temp), _possibleConstructorReturn(_this, _ret);}EditCompanyByOwnerForm.prototype.

  render = function render() {var _cx;var _props =






















    this.props,locale = _props.locale,handleSubmit = _props.handleSubmit,translate = _props.translate,editCompanyByOwnerSubmitting = _props.editCompanyByOwnerSubmitting,array = _props.array,disableCompanyForm = _props.disableCompanyForm,isMobile = _props.isMobile,fields = _props.fields,error = _props.error,isRtl = _props.isRtl,changeValue = _props.changeValue,receiveGeocodedPlace = _props.receiveGeocodedPlace,geocodedPlace = _props.geocodedPlace,geocodeFailed = _props.geocodeFailed,isAgent = _props.isAgent,openReportIssueModal = _props.openReportIssueModal,anyTouched = _props.anyTouched,initialValues = _props.initialValues,userData = _props.userData,phoneNumber = _props.phoneNumber,loading = _props.loading;

    var userHasCompany = !!(0, _get2.default)(this.props, 'userData.data.agent_data.agency_id');
    var pageIsNotActivated = (0, _get2.default)(this.props, 'initialValues.id') &&
    !((0, _get2.default)(this.props, 'initialValues.page.enabled') && (0, _get2.default)(this.props, 'initialValues.page.until'));

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.formWrap, (_cx = {}, _cx[styles.inactive] = !!disableCompanyForm, _cx)) },
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement('h1', null, translate('editOwner', userHasCompany ? 'editProfessionalPage' : 'createProfessionalPage')),
          _react2.default.createElement('p', null, translate('editOwner', 'editProfessionalPageText')),
          pageIsNotActivated && _react2.default.createElement('p', { className: styles.warnMessage },
            _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.iconWrapper, 'icon icon-attention') },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' })),


            this.props.translate('editOwner', 'warnMessage'))),


        _react2.default.createElement('form', { noValidate: 'noValidate' },
          _react2.default.createElement('div', { className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formRowTitle }, translate('editOwner', 'companyDetails')),
            _react2.default.createElement('div', { className: styles.rowBlock },
              _react2.default.createElement('div', { className: styles.title },
                translate('editOwner', 'type'), _react2.default.createElement('span', { className: 'req' }, '*')),

              _react2.default.createElement(_reactScroll.Element, { name: 'type', className: styles.content },
                this.renderSelect())),


            _react2.default.createElement('div', { className: styles.rowBlock },
              _react2.default.createElement('div', { className: styles.title },
                translate('editOwner', 'name'), _react2.default.createElement('span', { className: 'req' }, '*')),

              _react2.default.createElement(_reactScroll.Element, { name: 'name', className: styles.content },
                _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
                  translate: translate,
                  classNameTabs: 'project-form',
                  className: 'form-control',
                  name: 'name',
                  locale: locale,
                  isInput: true,
                  isOptionalLangsDisabled: !(0, _get2.default)(this.props, 'fields.name_he') }))),



















            _react2.default.createElement('div', { className: styles.rowBlock },
              _react2.default.createElement('div', { className: styles.title }, translate('editOwner', 'working_since')),
              _react2.default.createElement('div', { className: styles.workingSince },
                this.renderField('working_since', _publish2.default.working_since, 'YYYY')))),



          _react2.default.createElement('div', { className: styles.formRow },
            _react2.default.createElement(_reactScroll.Element, { name: 'branches', className: styles.formRow },
              _react2.default.createElement('div', { className: styles.content },
                _react2.default.createElement('div', { className: styles.rowBlock },
                  _react2.default.createElement('div', { className: styles.title }, translate('editOwner', 'phone_number'), _react2.default.createElement('span', { className: 'req' }, '*')),
                  !loading &&
                  _react2.default.createElement(_reduxForm.Field, {
                    name: 'phone_number',
                    isRtl: this.props.isRtl,
                    translate: translate,
                    locale: this.props.locale,
                    label: '' + this.props.translate('editOwner', 'phone_number'),
                    component: this.renderPhoneNumber,
                    required: true,
                    props: { phoneNumber: phoneNumber },
                    validate: this.props.validatePhoneNumber })))),













            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.rowBlock, styles.logoWrapper) },
              _react2.default.createElement('div', { className: styles.title },
                translate('editOwner', 'logo'), _react2.default.createElement('span', { className: 'req' }, '*')),

              _react2.default.createElement(_reactScroll.Element, { name: 'image', className: styles.content },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'image',
                  props: { classNames: 'uploadImg' },
                  component: this.renderLogoUploadAssetWidget })))),




          _react2.default.createElement(_reactScroll.Element, { name: 'branches', className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formRowTitle }, translate('editOwner', 'address')),
            _react2.default.createElement('div', { className: styles.content },
              _react2.default.createElement(_components.EditCompanyByOwnerBranch, {
                push: array.push,
                locale: locale,
                translate: translate,
                token: (0, _get2.default)(this.props, 'userData.data.access_token'),
                isMobile: isMobile,
                fields: fields,
                error: error,
                isRtl: isRtl,
                changeValue: changeValue,
                receiveGeocodedPlace: receiveGeocodedPlace,
                geocodedPlace: geocodedPlace,
                geocodeFailed: geocodeFailed,
                isAgent: isAgent,
                reportIssue: openReportIssueModal,
                anyTouched: anyTouched,
                initialValues: initialValues,
                userData: userData }))),



          _react2.default.createElement('div', { className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formRowTitle }, translate('editOwner', 'gallery')),
            _react2.default.createElement('div', { className: styles.imagesWrapper },
              _react2.default.createElement('div', { className: styles.title },
                translate('editOwner', 'projectImages')),

              _react2.default.createElement(_reactScroll.Element, { name: 'images', className: styles.content },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'images',
                  props: { multiple: true },
                  component: this.renderUploadAssetWidget })))),




          _react2.default.createElement(_reactScroll.Element, { name: 'description', className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formRowTitle },
              translate('editOwner', 'aboutCompany')),

            _react2.default.createElement('div', { className: styles.aboutCompanyWrapper },
              _react2.default.createElement('p', { className: styles.title },
                translate('editOwner', 'aboutCompany'), _react2.default.createElement('span', { className: 'req' }, '*')),

              _react2.default.createElement('div', { className: styles.descriptionWrapper },
                _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
                  translate: translate,
                  classNameTabs: 'project-form',
                  name: 'description',
                  locale: locale,
                  isOptionalLangsDisabled: !(0, _get2.default)(this.props, 'fields.description_he') })))),




          _react2.default.createElement(_reactScroll.Element, { name: 'advantages', className: styles.formRow },
            _react2.default.createElement(_components.EditOwnerAdvantages, {
              locale: locale,
              translate: translate,
              push: array.push })),


          _react2.default.createElement(_reactScroll.Element, { name: 'additional_info', className: styles.formRow },
            _react2.default.createElement('div', { className: styles.additionalInfoWrapper },
              _react2.default.createElement('div', { className: styles.title },
                translate('editOwner', 'additional_info')),

              _react2.default.createElement('div', { className: styles.additionalInfo },
                _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
                  translate: translate,
                  name: 'additional_info',
                  classNameTabs: 'project-form',
                  locale: locale,
                  isOptionalLangsDisabled: !(0, _get2.default)(this.props, 'fields.additional_info_he') })))),




          _react2.default.createElement('button', {
              onClick: this.handleClick,
              className: styles.submit,
              disabled: editCompanyByOwnerSubmitting },

            editCompanyByOwnerSubmitting ? _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }) : translate('editOwner', userHasCompany ? 'sendRequest' : 'sendRequestCreate')))));




  };return EditCompanyByOwnerForm;}(_react.Component);


var scrollToFirstError = function scrollToFirstError(errors) {
  if (!errors) {return;}
  var errorFields = Object.keys(errors);

  _reactScroll.scroller.scrollTo(errorFields[0], {
    duration: 500,
    smooth: true,
    offset: -95 });

};

EditCompanyByOwnerForm.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  error: _propTypes2.default.object,
  errors: _propTypes2.default.object,
  reset: _propTypes2.default.func,
  array: _propTypes2.default.object,
  change: _propTypes2.default.func,
  company: _propTypes2.default.object,
  changeValue: _propTypes2.default.func,
  registerNewField: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  addAssetToUnsuspend: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  editCompanyByOwnerSubmitting: _propTypes2.default.bool,
  userData: _propTypes2.default.object,
  sendEditCompanyByOwnerForm: _propTypes2.default.func,
  createCompanyByOwner: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  uploadImageTimeout: _propTypes2.default.func,
  initialValues: _propTypes2.default.object,
  loadingError: _propTypes2.default.object,
  handleSubmit: _propTypes2.default.func,
  disableCompanyForm: _propTypes2.default.bool,
  receiveGeocodedPlace: _propTypes2.default.func,
  geocodedPlace: _propTypes2.default.object,
  geocodeFailed: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  openReportIssueModal: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  anyTouched: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  fetchReCaptchaToken: _propTypes2.default.func,
  captchaIdentifier: _propTypes2.default.string,
  captcha: _propTypes2.default.string,
  onPhoneChange: _propTypes2.default.func,
  phoneNumber: _propTypes2.default.string,
  countryCode: _propTypes2.default.string,
  phoneNumberIsInvalid: _propTypes2.default.bool,
  validatePhoneNumber: _propTypes2.default.func,
  loading: _propTypes2.default.bool };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'editCompanyByOwnerForm',
  enableReinitialize: true,
  validate: _validate2.default,
  onSubmitFail: function onSubmitFail(errors) {return scrollToFirstError(errors);} })(
EditCompanyByOwnerForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditCompanyByOwnerForm/EditCompanyByOwnerForm.js
// module id = 2660
// module chunks = 0